import {
  Badge,
  Divider,
  Icon,
  Popover,
  Select,
  Table,
  Tooltip,
  message,
} from "antd";
import axios from "axios";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { UPDATE_REFILL } from "../../ActionTypes/ActionTypes";
import OrderSheetModal from "../FetchOrderList/OrderSheetModal";

import "./RefillsList.css";

const { Column } = Table;
const { Option } = Select;

class ConfirmedRefillsLists extends Component {
  state = {
    loading: false,
    sheetLoad: false,
    generateData: [],
    visibleOrderSheet: false,
    refillId: "",
    editRowId: "",
    status: "",
    response: "",
    alertDate: "",
    deliveryDate: "",
    nextStartDate: "",
    remark: "",
  };

  onCall = (record) => {
    axios({
      method: "get",
      url: `http://18.209.232.93/click2call?receiver=${record.mobile_number}`,
    }).then((response) => {
      console.log(response.data);
    });
  };

  onEdit = (record) => {
    console.log(record);
    this.setState({
      editRowId: record.id,
      status: record.status,
      response: record.response,
      alertDate: record.alert_date,
      deliveryDate: record.delivery_date,
      nextStartDate: record.next_start_date,
      remark: record.remark,
    });
  };

  handleResponseChange = (value) => {
    this.setState({
      response: value,
    });
  };

  handleStatusChange = (value) => {
    // console.log(value);
    this.setState({
      status: value,
    });
  };

  onDateChange = (record, dateString) => {
    this.setState({
      alertDate: dateString,
    });
  };

  onDeliveryDateChange = (record, dateString) => {
    this.setState({
      deliveryDate: dateString,
    });
  };

  onNextStartDateChange = async (record, dateString) => {
    await this.setState({
      nextStartDate: dateString,
    });
  };

  disabledDeliveryDate = (current) => {
    const { nextStartDate } = this.state;
    return nextStartDate == null || nextStartDate === ""
      ? ""
      : current && current > moment(nextStartDate).add(-1, "days").endOf("day");
  };

  handleRemarkChange = (event) => {
    this.setState({
      remark: event.target.value,
    });
  };

  onSave = async () => {
    const {
      editRowId,
      response,
      alertDate,
      remark,
      nextStartDate,
      deliveryDate,
    } = this.state;
    const { refillsList, updateRefill } = this.props;

    this.setState({ loading: true });

    const data = refillsList.filter((refill) => refill.id === editRowId)[0];
    const idToUpdate = refillsList.indexOf(data);

    if (response === "Didn't Pick up First Call") {
      data.response = "Didn't Pick up First Call";
      data.snooze_count = 1;
      data.status = "Active";
      data.remark = remark;
      data.next_start_date = nextStartDate;
      data.delivery_date = deliveryDate;
    } else if (response === "Not Reachable/Switched Off") {
      data.response = "Not Reachable/Switched Off";
      data.snooze_count = 1;
      data.status = "Active";
      data.alert_date = moment().add(1, "days").format("YYYY-MM-DD");
      data.remark = remark;
      data.next_start_date = nextStartDate;
      data.delivery_date = deliveryDate;
    } else if (response === "Didn't Pick up Second Call") {
      data.response = "Didn't Pick up Second Call";
      data.snooze_count = 2;
      data.status = "Active";
      data.alert_date = moment().add(1, "days").format("YYYY-MM-DD");
      data.remark = remark;
      data.next_start_date = nextStartDate;
      data.delivery_date = deliveryDate;
    } else if (response === "Didn't Pick up Third Call") {
      data.response = "Didn't Pick up Third Call";
      data.snooze_count = 2;
      data.status = "Active";
      data.alert_date = moment().add(1, "days").format("YYYY-MM-DD");
      data.remark = remark;
      data.next_start_date = nextStartDate;
      data.delivery_date = deliveryDate;
    } else if (response === "Didn't Pick up Fourth Call") {
      data.response = "Didn't Pick up Fourth Call";
      data.snooze_count = 0;
      data.status = "Inactive";
      data.remark = remark;
      data.next_start_date = nextStartDate;
      data.delivery_date = deliveryDate;
    } else if (response === "Call me on X Date") {
      data.response = "Call me on X Date";
      data.snooze_count = 0;
      data.status = "On Hold";
      data.alert_date = alertDate; // manual date set && formats of date
      data.remark = remark;
      data.next_start_date = nextStartDate;
      data.delivery_date = deliveryDate;
    } else if (response === "Call me After Doctor's Appointment") {
      data.response = "Call me After Doctor's Appointment";
      data.snooze_count = 0;
      data.status = "On Hold";
      data.alert_date = alertDate; // manual date set && formats of date
      data.remark = remark;
      data.next_start_date = nextStartDate;
      data.delivery_date = deliveryDate;
    } else if (response === "Discontinue Caredose") {
      data.response = "Discontinue Caredose";
      data.snooze_count = 0;
      data.status = "Inactive";
      data.remark = remark;
      data.next_start_date = nextStartDate;
      data.delivery_date = deliveryDate;
    } else if (response === "Will Share the prescription") {
      data.response = "Will Share the prescription";
      data.snooze_count = 1;
      data.status = "Pending"; // just check and confirm this with GA
      data.remark = remark;
      data.next_start_date = nextStartDate;
      data.delivery_date = deliveryDate;
    } else if (response === "Will contact Partners Pharmacy") {
      data.response = "Will contact Partners Pharmacy";
      data.snooze_count = 1;
      data.status = "On Hold";
      data.remark = remark;
      data.next_start_date = nextStartDate;
      data.delivery_date = deliveryDate;
    } else if (response === "Order Confirmed") {
      data.response = "Order Confirmed";
      data.snooze_count = 0;
      data.status = "Confirmed";
      data.remark = remark;
      data.next_start_date = nextStartDate;
      data.delivery_date = deliveryDate;
    } else if (response === "On Hold") {
      data.response = "On Hold";
      data.snooze_count = 0;
      data.status = "On Hold";
      data.remark = remark;
      data.next_start_date = nextStartDate;
      data.delivery_date = deliveryDate;
    } else if (response === "Active") {
      data.response = "Active";
      data.snooze_count = 0;
      data.status = "Active";
      data.remark = remark;
      data.next_start_date = nextStartDate;
      data.delivery_date = deliveryDate;
    }

    await axios({
      method: "put",
      url: `/carefills/${editRowId}.json`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
      data: {
        carefill: {
          response: data.response,
          alert_date: data.alert_date,
          snooze_count: data.snooze_count,
          remark: data.remark,
          next_start_date: data.next_start_date,
          delivery_date: data.delivery_date,
        },
      },
    }).then(() => {
      updateRefill(idToUpdate, data);
      const orderID = data.order_identifier;
      const ordID =
        Number(orderID.split("–")[0]) || Number(orderID.split("-")[0]);

      // changing order status manually
      axios({
        method: "put",
        url: `/orders/${ordID}.json`,
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
        data: {
          order: {
            status: data.status,
          },
        },
      }).then((res) => {
        console.log(res.data);
      });

      this.setState(
        {
          editRowId: "",
          status: "",
          response: "",
          alertDate: "",
          remark: "",
          nextStartDate: "",
          delivery_date: "",
        },
        () => {
          this.setState({
            loading: false,
          });
          message.success("Refill Updated Successfully");
        }
      );
    });
  };

  handleOrderSheet = async (record) => {
    await axios({
      method: "get",
      url: `/order_sheet.json?refill_number=${record.id}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      this.setState(
        {
          generateData: response.data,
        },
        this.setState({
          visibleOrderSheet: true,
        })
      );
    });
  };

  handleGoToOrderPage = (record) => {
    const { history } = this.props;
    const orderID = record.order_identifier;
    const ordID =
      Number(orderID.split("–")[0]) || Number(orderID.split("-")[0]);
    history.push(`/orders/${ordID}`);
  };

  handleOrderSheetCancel = () => {
    this.setState({
      visibleOrderSheet: false,
    });
  };

  onCancel = () => {
    this.setState({
      editRowId: "",
      generateData: [],
      status: "",
      response: "",
      alertDate: "",
      remark: "",
      nextStartDate: "",
      delivery_date: "",
    });
  };

  render() {
    const { refillsList } = this.props;
    const { loading, editRowId, response, visibleOrderSheet, generateData } =
      this.state;

    // console.log(this.state.deliveryDate);

    const responses = ["Active", "On Hold"];

    const responseOption = responses.map((resp) => (
      <Option key={resp}>{resp}</Option>
    ));

    const toHoldContent = (
      <div>
        <p>PLEASE CONFIRM OR MOVE TO HOLD</p>
      </div>
    );

    const toInactiveContent = (
      <div>
        <p>PLEASE CONFIRM OR MOVE TO INACTIVE </p>
      </div>
    );

    // console.log(moment().diff(moment('2018-11-15'), 'days'));

    return (
      <div>
        <Table
          dataSource={refillsList}
          pagination={false}
          scroll={{ x: "2300px" }}
          loading={loading}
          size="middle"
          rowClassName={(record) =>
            record.snooze_count === 1
              ? "yellowBack"
              : record.snooze_count === 2
              ? "redBack"
              : null
          }
          rowKey="id"
          style={{ overflow: "wrap" }}
        >
          <Column
            title="Id"
            width="50px"
            fixed="left"
            align="center"
            dataIndex="id"
          />
          <Column
            title="Name"
            fixed="left"
            align="center"
            // dataIndex="patient_name"
            render={
              (record) =>
                record.response === "Will Share the prescription" &&
                moment().diff(moment(record.alert_date), "days") > 7 ? (
                  <Popover
                    title="Message"
                    trigger="hover"
                    content={toHoldContent}
                  >
                    <span
                      style={{
                        color:
                          record.response === "Will Share the prescription" &&
                          moment().diff(moment(record.alert_date)) > 7
                            ? "red"
                            : "",
                      }}
                    >
                      {record.patient_name}{" "}
                      {record.is_vip ? (
                        <Badge
                          count="VIP"
                          style={{ backgroundColor: "#52c41a" }}
                        />
                      ) : (
                        ""
                      )}
                    </span>
                  </Popover>
                ) : record.response === "Will contact Partners Pharmacy" &&
                  moment().diff(moment(record.alert_date), "days") > 14 ? (
                  <Popover
                    title="Message"
                    trigger="hover"
                    content={toInactiveContent}
                  >
                    {record.patient_name}{" "}
                    {record.is_vip ? (
                      <Badge
                        count="VIP"
                        style={{ backgroundColor: "#52c41a" }}
                      />
                    ) : (
                      ""
                    )}
                  </Popover>
                ) : (
                  <span>
                    {record.patient_name}{" "}
                    {record.is_vip ? (
                      <Badge
                        count="VIP"
                        style={{ backgroundColor: "#52c41a" }}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                )

              // <Popover
              //     title={record.response === 'Will Share the prescription' && moment().diff(moment(record.alert_date)) > 14 ? 'Message' : ''}
              //     trigger="hover"
              //     content={record.response === 'Will Share the prescription' && moment().diff(moment(record.alert_date)) > 14 ? toHoldContent : ''}
              // >
              //     <span style={{ color: record.response === 'Will Share the prescription' && moment().diff(moment(record.alert_date)) > 14 ? 'red' : '' }}>
              //         {record.patient_name}
              //     </span>
              // </Popover>
            }
            width="200px"
          />
          <Column
            title="Mobile"
            fixed="left"
            width="150px"
            align="center"
            render={(record) => (
              <span>
                {/* <p>{record.mobile_number}</p> */}
                <p>
                  {record.contact_number == null || record.contact_number === ""
                    ? record.mobile_number
                    : record.contact_number}
                </p>

                <span>
                  <Tooltip placement="top" title="Call">
                    <Icon
                      onClick={() => this.onCall(record)}
                      type="phone"
                      theme="twoTone"
                      style={{ fontSize: "18px", cursor: "pointer" }}
                    />
                  </Tooltip>
                </span>

                <Divider type="vertical" />

                <span>
                  <Tooltip placement="top" title="Message">
                    <Icon
                      onClick={() => this.onMessage(record)}
                      type="message"
                      theme="twoTone"
                      style={{ fontSize: "18px", cursor: "pointer" }}
                    />
                  </Tooltip>
                </span>
              </span>
            )}
          />
          <Column
            title="Location"
            align="center"
            dataIndex="location"
            width="150px"
          />
          <Column
            title="Start Date"
            align="center"
            dataIndex="start_date"
            width="150px"
          />
          <Column
            title="End Date"
            align="center"
            dataIndex="end_date"
            width="150px"
          />
          <Column
            title="Tenure"
            align="center"
            width="150px"
            render={(record) =>
              `${
                moment(record.end_date).diff(
                  moment(record.start_date),
                  "days"
                ) + 1
              } Days`
            }
          />
          <Column
            title="Next Start Date"
            align="center"
            render={(record) => record.next_start_date}
            width="200px"
          />
          <Column
            title="Next Delivery Date"
            align="center"
            render={(record) => record.delivery_date}
            width="200px"
          />
          <Column
            title="Response"
            align="center"
            width="200px"
            render={(record) =>
              editRowId !== record.id ? (
                record.response
              ) : (
                <div>
                  <Select
                    showSearch
                    style={{ width: 200 }}
                    placeholder="Select a reason"
                    defaultValue={response}
                    optionFilterProp="children"
                    onChange={this.handleResponseChange}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {responseOption}
                  </Select>
                </div>
              )
            }
          />
          <Column
            title="Alert Date"
            // fixed="right"
            align="center"
            width="150px"
            render={(record) => record.alert_date}
          />
          <Column
            title="Remark"
            align="center"
            width="300px"
            render={(record) => record.remark}
          />
          <Column
            title="Action"
            fixed="right"
            align="center"
            width="150px"
            render={(record) =>
              editRowId === record.id ? (
                <span>
                  <span>
                    <Tooltip placement="top" title="Save">
                      <Icon
                        type="check-circle"
                        onClick={this.onSave}
                        theme="twoTone"
                        twoToneColor="#52c41a"
                        style={{ fontSize: "20px", cursor: "pointer" }}
                      />
                    </Tooltip>
                  </span>

                  <Divider type="vertical" />

                  <span>
                    <Tooltip placement="top" title="Cancel">
                      <Icon
                        type="close-circle"
                        onClick={this.onCancel}
                        theme="twoTone"
                        twoToneColor="#eb2f96"
                        style={{ fontSize: "20px", cursor: "pointer" }}
                      />
                    </Tooltip>
                  </span>
                </span>
              ) : (
                <span>
                  <Tooltip placement="top" title="Edit">
                    <Icon
                      type="edit"
                      onClick={() => this.onEdit(record)}
                      theme="twoTone"
                      style={{ fontSize: "20px", cursor: "pointer" }}
                    />
                  </Tooltip>

                  <Divider type="vertical" />

                  <Tooltip placement="top" title="Order Sheet">
                    <Icon
                      type="file-text"
                      onClick={() => this.handleOrderSheet(record)}
                      theme="twoTone"
                      style={{ fontSize: "20px", cursor: "pointer" }}
                    />
                  </Tooltip>

                  <Divider type="vertical" />

                  <Tooltip placement="top" title="Go to Order ...">
                    <Icon
                      type="arrow-right"
                      onClick={() => this.handleGoToOrderPage(record)}
                      theme="outlined"
                      style={{ fontSize: "20px", cursor: "pointer" }}
                    />
                  </Tooltip>
                </span>
              )
            }
          />
        </Table>

        <OrderSheetModal
          visible={visibleOrderSheet}
          onCancel={this.handleOrderSheetCancel}
          generateData={generateData}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  refillsList: state.RefillState.refillsList,
});

const mapDispatchToProps = (dispatch) => ({
  updateRefill: (id, data) =>
    dispatch({ type: UPDATE_REFILL, payload: { id, data } }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ConfirmedRefillsLists));



// WEBPACK FOOTER //
// ./src/component/RefillManagementSystem/ConfirmedRefillLists.js